import { useTheme } from "@mui/material";
import DSBox from "../../system-design/DSBox";
import DSTypography from "../../system-design/DSTypography";

export type AssetBoxProps = {
  label: string;
  imageUrl?: string;
  alt?: string;
};

const AssetBox = ({ label, imageUrl, alt }: AssetBoxProps) => {
  const { palette } = useTheme();

  return (
    <DSBox>
      <DSTypography
        variant="caption"
        sx={{
          display: "block",
          mb: 1,
          fontWeight: 600,
          color: palette.text.secondary,
        }}
      >
        {label}
      </DSTypography>
      <DSBox
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          aspectRatio: "1",
          borderRadius: 2,
          backgroundColor: palette.grey[200],
          overflow: "hidden",
          position: "relative",
        }}
      >
        {imageUrl ? (
          <img
            src={imageUrl}
            alt={alt || label}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
            onError={(e: React.SyntheticEvent<HTMLImageElement>) => {
              e.currentTarget.style.display = "none";
            }}
          />
        ) : (
          <DSTypography variant="caption" sx={{ color: palette.text.disabled }}>
            No image
          </DSTypography>
        )}
      </DSBox>
    </DSBox>
  );
};

export default AssetBox;
